import { render, staticRenderFns } from "./IconClipboard.vue?vue&type=template&id=6aad24a6"
import script from "./IconClipboard.vue?vue&type=script&lang=js"
export * from "./IconClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports